import cn from 'classnames';

import { IConDefaultType } from '../../types';

export enum ArrowForwardIconVariant {
  DEFAULT = 'default',
}
export interface ICircleDeleteIconProps extends IConDefaultType {
  variant?: ArrowForwardIconVariant;
}

export default function ArrowForwardIcon({
  color,
  className,
  size = 24,
  rotate,
  flip,
  variant = ArrowForwardIconVariant.DEFAULT,
}: ICircleDeleteIconProps) {
  const _color = color ?? 'black';
  const style = {
    width: size,
    minWidth: size,
    height: size,
    transform: `rotate(${rotate}deg)`,
  };

  return (
    <i className={cn('dds-icon', className, { flip })} style={style}>
      {variant === ArrowForwardIconVariant.DEFAULT && (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M7 16L13 10L7 4"
            stroke={_color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            x="50%"
            y="50%"
          />
        </svg>
      )}
    </i>
  );
}
